const EARTH_RADIUS = 2.5;
const CAMERA_D = 8;

export { CAMERA_D, EARTH_RADIUS }
